import { connect } from "react-redux";
import { Selectors } from "@/store/saloonProfile/selectors";
import SEO from "./Seo";

const mSp = (state) => ({
  avatar: Selectors.getLogo(state),
  meta: Selectors.getSeoMeta(state),
  saloonId: Selectors.getId(state),
});

export default connect(mSp)(SEO);
